import { FileList, Filters, ListHeader, ListPageLayout, StaticFiltersLayout } from 'framework/list';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import PermissionsAuditManual from './manual';
import useAuditService from 'domain/audit/shared/auditService';
import AuditDateFilter from '../filter/AuditDateFilter';

const PermissionsConfigurationList = () => {
  const { getPermissionsConfigurationReport } = useAuditService();
  const { getToday } = useDateService();

  const filters = (
    <Filters>
      <StaticFiltersLayout actionButtonName="Download">
        <AuditDateFilter source="dateTime" />
      </StaticFiltersLayout>
    </Filters>
  );

  return (
    <FileList
      getDataMethod={getPermissionsConfigurationReport}
      defaultFilters={{
        dateTime: {
          eq: getToday().format(DATE_FORMAT.API),
        },
      }}
    >
      <ListPageLayout
        showTotal={false}
        header={<ListHeader label="Permissions Configuration" icon="fa-lock" />}
        filter={filters}
      >
        <PermissionsAuditManual />
      </ListPageLayout>
    </FileList>
  );
};

export default PermissionsConfigurationList;
